import { CombinedGraphQLErrors } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLErrorCodes } from '@repo/common';
export function isGraphqlUnauthenticatedError(error) {
    if (!CombinedGraphQLErrors.is(error)) {
        return false;
    }
    return error.errors.some(gqlError => {
        if (!gqlError || typeof gqlError !== 'object') {
            return false;
        }
        const { extensions } = gqlError;
        return extensions?.code === GraphQLErrorCodes.UNAUTHENTICATED;
    });
}
export function isMutationOperation(operation) {
    const definition = getMainDefinition(operation.query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
}
//# sourceMappingURL=create-auth-error-link-helpers.js.map